import { OverviewComponent } from "../components";
import { useOverview } from "./useOverview";

const Overview = (): JSX.Element => {
  const {
    isLoading,
    projectDetails,
    // stackedChartData,
    // xAxisLabels,
    tags,
    badges,
    certifications,
    standardSpecificDefinition,
    restorationUnits,
  } = useOverview();
  return (
    <div>
      {!isLoading && standardSpecificDefinition && (
        <OverviewComponent
          projectDetails={projectDetails}
          // stackedChartData={stackedChartData}
          // xAxisLabels={xAxisLabels}
          tags={tags}
          badges={badges}
          certifications={certifications}
          standardSpecificDefinition={standardSpecificDefinition}
          restorationUnits={restorationUnits}
        />
      )}
    </div>
  );
};

export default Overview;
